import { useEffect } from 'react';

const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;

export function useDisableSwipes(disabled: boolean = true) {
  useEffect(() => {
    if (!tg) return;

    if (disabled) {
      if (typeof tg.disableVerticalSwipes === 'function') {
        tg.disableVerticalSwipes();
      }
    } else {
      if (typeof tg.enableVerticalSwipes === 'function') {
        tg.enableVerticalSwipes();
      }
    }

    return () => {
      if (typeof tg.enableVerticalSwipes === 'function') {
        tg.enableVerticalSwipes();
      }
    };
  }, [disabled]);
}
